import { useWindowDimensions } from '../util/util'
const usePadding = () => {
  const viewPortWidth = useWindowDimensions()

  const getPadding = (): number => {
    if (viewPortWidth < 600) {
      // mobile
      return 24
    }

    if (viewPortWidth >= 600 && viewPortWidth < 1025) {
      //tabs
      return 72
    }

    if (viewPortWidth > 1025 && viewPortWidth < 1200) {
      // medium size laptops
      return 72
    }

    if (viewPortWidth >= 1200 && viewPortWidth <= 1600) {
      // large screen laptops
      return viewPortWidth / 10 - 10
    }

    if (viewPortWidth > 1600) {
      // large screen laptops
      return viewPortWidth / 7.5 + 20
    }

    return 100
  }

  const padding = getPadding()
  return padding
}

export default usePadding
